var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrossFromWebsite(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2634"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2434",
    fill: "rgba(255,255,255,0)",
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-times",
    d: "M12.504 10.001l3.75-3.75a1.179 1.179 0 000-1.667l-.833-.833a1.179 1.179 0 00-1.667 0l-3.75 3.75-3.755-3.75a1.179 1.179 0 00-1.667 0l-.833.83a1.179 1.179 0 000 1.667l3.75 3.75-3.75 3.753a1.179 1.179 0 000 1.667l.833.833a1.179 1.179 0 001.667 0l3.755-3.75 3.75 3.75a1.179 1.179 0 001.667 0l.833-.833a1.179 1.179 0 000-1.667z",
    fill: "#a6a6a6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossFromWebsite);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconCrossFromWebsite.6526d8dc.svg";
export { MemoForwardRef as ReactComponent };